import getConfig from 'next/config';
import {
  getAddOns,
  addAddOns,
  removeAddOns,
  addEquipmentAddOn,
  removeEquipmentAddOn,
  getMobileSecurityAddOn,
} from '../../integration/addons.api';
import { formatAddOnsData } from '../../../util/Format.util';
import useLocalStorage from '../../hooks/useLocalStorage';
import getCarts from '../../integration/cart.api';
import {
  addToCartAnalytics,
  viewItemListAnalytics,
  removeFromCartAnalytics,
} from '../../../util/gtm';
import { getCartInfo } from '../eir-cart/cart.util';
import { getCookie, getTokenFromCookies } from '../../hooks/useCookie';
import { SERVICE_DOMAINS, SERVICE_GROUPS } from '../shared/Constants';

const { publicRuntimeConfig } = getConfig();

const localStore = useLocalStorage();
const { VOIP, IPTV } = SERVICE_DOMAINS;
const { DUALPLAY, TV } = SERVICE_GROUPS;
export const onLoadAddons = async ({ graphql, localStorage }) => {
  try {
    if (localStorage.hasValue('prospectuuid')) {
      const { getCart: cart } = await getCarts({
        graphql,
        variables: { reference: localStorage.getLocalStorage('prospectuuid') },
      });

      const cartInfo = getCartInfo(cart);

      return { cart, cartInfo };
    }
  } catch (error) {
    console.error(error);
    return { error };
  }
};

export const getAddons = async serviceGroupCode => {
  try {
    const variables = {
      offerTypeCode: 'POSTPAY',
      serviceGroupCode,
      channel: getCookie('channel')
        ? getCookie('channel')
        : `${publicRuntimeConfig.NEXT_PUBLIC_CHANNEL}`,
    };
    let addOnsData = await getAddOns({ variables });
    addOnsData = addOnsData.map(addOn => ({
      ...addOn,
      description: addOn.displayName || addOn.description,
    }));
    // viewItemListAnalytics(`Addons-${serviceGroupCode}`, addOnsData);
    return formatAddOnsData(addOnsData);
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const addAddOn = async (graphql, catalogCode, serviceGroup, cartOffers = []) => {
  try {
    const prospect = localStore.getLocalStorage('PROSPECTUUID');
    let offerId = '';
    if (serviceGroup === VOIP || serviceGroup === DUALPLAY) {
      offerId = cartOffers.offers.filter(ele => ele.baseOffer.serviceGroup === DUALPLAY)[0]?.id;
    }
    if (serviceGroup === IPTV) {
      offerId = cartOffers.offers.filter(ele => ele.baseOffer.serviceGroup === TV)[0]?.id;
    }
    const variables = {
      reference: prospect,
      catalogCode,
      offerId,
      cartType: 'NEW_ACQUISITION',
    };
    const data = await addAddOns({ graphql, variables });
    addToCartAnalytics(data);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const removeAddOn = async (graphql, catalogCode, serviceGroup, cartOffers = []) => {
  try {
    const prospect = localStore.getLocalStorage('PROSPECTUUID');
    let offerId = 0;
    let addOnId = 0;

    const addOnArrays = cartOffers.offers.filter(offer => offer.addOns !== undefined);
    const selectedAddOnArray = addOnArrays.map(arr =>
      arr.addOns.filter(ele => {
        if (ele.catalogCode === catalogCode) {
          offerId = arr.id;
        }
        return ele.catalogCode === catalogCode;
      })
    );
    const targetArray = selectedAddOnArray.filter(ele => ele.length > 0)[0];
    addOnId = targetArray[0].id;

    const variables = {
      reference: prospect,
      offerId,
      addOnId,
      cartType: 'NEW_ACQUISITION',
    };
    const data = await removeAddOns({ graphql, variables });
    removeFromCartAnalytics(data);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const addEquipmentAddOns = async (graphql, catalogCode, variant, cartOffers = []) => {
  const selectedOffer = cartOffers.offers.filter(
    offer => offer?.baseOffer?.serviceGroup === 'MOBILE'
  );
  const sortedOffersInCart = selectedOffer.sort((a, b) => b.id - a.id);
  try {
    const prospect =
      localStore.getLocalStorage('PROSPECTUUID') ||
      getCookie('reference') ||
      localStore.getLocalStorage('REF');
    const cartOfferId = sortedOffersInCart[0]?.id;
    const equipmentId = sortedOffersInCart[0]?.equipments.filter(
      eq => eq.catalogCode === variant.code
    )[0]?.id;
    let variable = {};
    variable = {
      reference: prospect,
      catalogCode,
      cartOfferId,
      equipmentId,
      token: getTokenFromCookies(),
      cartType: getCookie('cart_Type'),
    };
    const data = await addEquipmentAddOn({ graphql, variables: variable });
    addToCartAnalytics(data);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const removeEquipmentAddOns = async (graphql, variant, cartOffers = []) => {
  const selectedOffer = cartOffers.offers.filter(
    offer => offer?.baseOffer?.serviceGroup === 'MOBILE'
  );
  const sortedOffersInCart = selectedOffer.sort((a, b) => b.id - a.id);
  try {
    const prospect =
      localStore.getLocalStorage('PROSPECTUUID') ||
      getCookie('reference') ||
      localStore.getLocalStorage('REF');
    const offerId = sortedOffersInCart[0]?.id;
    const addOnId = sortedOffersInCart[0]?.equipments.filter(
      eq => eq.catalogCode === variant.code
    )[0]?.addOn.id;
    const equipmentId = sortedOffersInCart[0]?.equipments.filter(
      eq => eq.catalogCode === variant.code
    )[0]?.id;
    const variables = {
      reference: prospect,
      offerId,
      addOnId,
      equipmentId,
      token: getTokenFromCookies(),
      cartType: getCookie('cart_Type'),
    };
    const data = await removeEquipmentAddOn({ graphql, variables });
    removeFromCartAnalytics(data);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const getMobileSecurityAddons = async (graphql, serviceGroupCode) => {
  try {
    const variables = {
      offerTypeCode: 'POSTPAY',
      serviceGroupCode,
      channel: 'ESHOP',
      codes: 'MOBILE_SECURITY',
    };
    let addOnsData = await getMobileSecurityAddOn({ graphql, variables });
    addOnsData = addOnsData.map(addOn => ({
      ...addOn,
      description: addOn.displayName || addOn.description,
    }));
    viewItemListAnalytics(`Addons-${serviceGroupCode}`, addOnsData);
    return formatAddOnsData(addOnsData);
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const addMobileSecurityAddOn = async (graphql, catalogCode, cartOffers = []) => {
  let offerId = '';
  const prospect = localStore.getLocalStorage('PROSPECTUUID');
  const selectedOffer = cartOffers.offers.filter(
    offer => offer?.baseOffer?.serviceGroup === 'MOBILE'
  );
  const sortedOffersInCart = selectedOffer.sort((a, b) => b.id - a.id);
  offerId = sortedOffersInCart[0]?.id;
  try {
    const variables = {
      reference: prospect,
      catalogCode,
      offerId,
      cartType: getCookie('cart_type') ? getCookie('cart_type') : 'NEW_ACQUISITION',
      token: getTokenFromCookies() || '',
    };
    const data = await addAddOns({ graphql, variables });
    addToCartAnalytics(data);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const removeMobileSecurityAddOn = async (graphql, catalogCode, cartOffers = []) => {
  const selectedOffer = cartOffers.offers.filter(
    offer => offer?.baseOffer?.serviceGroup === 'MOBILE'
  );
  const sortedOffersInCart = selectedOffer.sort((a, b) => b.id - a.id);
  try {
    const prospect = localStore.getLocalStorage('PROSPECTUUID');
    let offerId = 0;
    let addOnId = 0;
    offerId = sortedOffersInCart[0]?.id;
    addOnId = sortedOffersInCart[0].addOns.filter(ad => ad.catalogCode === catalogCode)[0]?.id;
    const variables = {
      reference: prospect,
      offerId,
      addOnId,
      cartType: getCookie('cart_type') ? getCookie('cart_type') : 'NEW_ACQUISITION',
      token: getTokenFromCookies() || '',
    };
    const data = await removeAddOns({ graphql, variables });
    removeFromCartAnalytics(data);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};
